import { Link } from 'react-router-dom';
import { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (views: number): string => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} - 在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          width={400}
          height={560}
        />
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            comic.status === '已完结'
              ? 'bg-accent-500 text-background-50'
              : 'bg-primary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-background-50 text-xs line-clamp-2">{comic.description}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 line-clamp-1 mb-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mb-2">{comic.author}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs font-medium text-foreground-700">{comic.rating}</span>
          </div>
          <div className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-eye-line"></i>
            <span>{formatViews(comic.views)}</span>
          </div>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {comic.categories.slice(0, 2).map((cat) => (
            <span
              key={cat}
              className="px-2 py-0.5 rounded-full text-xs bg-secondary-100 text-secondary-700"
            >
              {cat}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}